import { render, staticRenderFns } from "./MFTextareaEmoji.vue?vue&type=template&id=716f0054"
import script from "./MFTextareaEmoji.vue?vue&type=script&lang=js"
export * from "./MFTextareaEmoji.vue?vue&type=script&lang=js"
import style0 from "./MFTextareaEmoji.vue?vue&type=style&index=0&id=716f0054&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports